export function paint(element, active, activeClasses, idleClasses) {
  element.classList.remove(...activeClasses, ...idleClasses);
  element.classList.add(...(active ? activeClasses : idleClasses));
}

export function typing(target) {
  if (!(target instanceof Element)) return false;

  return target.closest('input, textarea, select, [contenteditable="true"]') !== null;
}

export function field(node, name) {
  return node.querySelector(`[data-field="${name}"]`);
}

export function role(node, name) {
  return node.querySelector(`[data-role="${name}"]`);
}

export function message(node, text) {
  node.hidden = !text;
  node.textContent = text ?? '';
}

export function hiddenField(name, value) {
  const field = document.createElement('input');

  field.type = 'hidden';
  field.name = name;
  field.value = value;

  return field;
}
